import { useNavigate } from "react-router-dom";
import makhanacart from "../../assets/home/testing.png";

const ContactUs = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/contact");
    };

    return (
        <>
            <div
                className="container-fluid"
                style={{
                    background: "linear-gradient(to right, #FFDA01, #F68422)",
                }}
            >
                <div className="container p-3">
                    <div className="row pt-5">
                        <div className="col-md-6 mb-5 d-flex align-items-center">
                            <div>
                                <h1
                                    style={{
                                        fontWeight: "700",
                                        color: "black",
                                    }}
                                >
                                    Makhana Snack,<br /> With Nutritions
                                </h1>

                                <h6
                                    className="mt-3"
                                    style={{
                                        color: "black",
                                        fontStyle: "italic",
                                    }}
                                >
                                    Wholesome Makhana Flavour, On The Go!
                                </h6>

                                <button
                                    className="mt-3 contact-btn"
                                    onClick={handleClick}
                                >
                                    Contact Here
                                </button>
                            </div>
                        </div>

                        <div className="col-md-6 mb-5">
                            <img
                                src={makhanacart}
                                alt="cart"
                                className="img-fluid"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactUs;
